import { useParams } from "react-router-dom";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import httpService from "../../../services/http/stores/outlet.service";
import { useEffect, useState } from "react";
import UnlimitLoading from "../../../components/ui-kit/unlimit-loading";
import UnlimitFieldDetails from "../../../components/ui-kit/unlimit-field-details";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import UnlimitHyperlink from "../../../components/ui-kit/unlimit-hyperlink";
import notificationService from "../../../services/toaster.service";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ShopsDetailsStock from "./Details/outlet-details-stock";
import { Collapse } from "antd";
import ShopDetailsLogs from "./Details/outlet-details-logs";

export default function ShopsDetails() {
  const [pageLoading, setPageLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const { id } = useParams();
  const [shops, setShops] = useState([]);
  const { t } = useTranslation();

  const getOutlets = async () => {
    try {
      setPageLoading(true);
      const response = await httpService.getOutlet(id);
      if (response && response.status === 200) {
        setShops(response.data.data);
        setIsActive(response.data.data.is_active == 0 ? true : false);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getOutlets();
    }
  }, [id]);

  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t("shop.shops"), link: "/outlets-list" },
    { label: t("shop.shopDetails"), active: true },
  ];

  const updateShop = async () => {
    const requestData = {
      is_active: isActive ? 1 : 0,
      id: id,
    };
    await httpService
      .updateOutlet(requestData, true)
      .then((response) => {
        if (response.status === 200) {
          notificationService.successMessage(t("shop.shopUpdateSuccess"));
          setIsActive(!isActive);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const items = [
    {
      key: "1",
      label: <p className="fw-bold">{t("shop.shopStock")}</p>,
      children: <ShopsDetailsStock id={id} />,
    },
    {
      key: "2",
      label: <p className="fw-bold">{t("tableColumnName.shopLogs")}</p>,
      children: <ShopDetailsLogs type="OUTLET" id={id} />,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex flex-column">
              <div className="page-title">
                <h3 className="text-black">{t("shop.shop")}</h3>
              </div>
              <UnlimitBreadcrumb items={breadcrumbItems} />
            </div>
          </div>
          {pageLoading ? (
            <div className="row d-flex justify-content-center">
              <UnlimitLoading width={50} height={50} />
            </div>
          ) : (
            shops && (
              <>
                <div className="row">
                  <div className="col-md-4">
                    <div className="border card p-3 mb-3">
                      <div className="d-flex justify-content-between flex-column align-items-center mb-2">
                        <div className="d-flex w-100 justify-content-end align-items-center">
                          
                          <span
                            className={`badge ${
                              !isActive ? "badge-linesuccess" : "badge-danger"
                            }`}
                          >
                            <a>
                              {!isActive
                                ? t("general.actions.active")
                                : t("general.actions.deactive")}
                            </a>
                          </span>
                        </div>
                        <div className="w-100 d-flex flex-column justify-content-center align-items-center h-75 mt-4">
                          <ImageWithBasePath
                            src={shops?.image}
                            height={120}
                            width={120}
                            type="link"
                          ></ImageWithBasePath>
                          <div className="mt-4 text-center">
                            <div className="text-black text-center fs-6">
                              <strong>{shops?.name}</strong>
                            </div>
                            <div className="text-center text-small text-muted">
                              Shop ID: {shops.outlet_code}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex w-100 mt-4 gap-3">
                        <UnlimitHyperlink
                          to={`/outlets/${id}/edit`}
                          className="btn btn-primary"
                          type="router-link"
                          style={{ flex: 1 }}
                        >
                          {t("general.actions.edit")}
                        </UnlimitHyperlink>
                        <button
                          className={`btn ${
                            isActive ? "btn-success" : "btn-danger"
                          }`}
                          onClick={updateShop}
                          style={{ flex: 1 }}
                        >
                          {isActive
                            ? t("general.actions.activate")
                            : t("general.actions.deactivate")}
                        </button>
                      </div>
                    </div>
                   
                  </div>
                  <div className="col-md-8">
                    <div className="p-3 card">
                      <div className="row mb-md-3">
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.contactName")}
                            details={shops.contact_name}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.phone")}
                            details={shops.phone}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.email")}
                            details={
                              <span
                                style={{
                                  wordWrap: "break-word",
                                  wordBreak: "break-all",
                                }}
                              >
                                {shops.email}
                              </span>
                            }
                          />
                        </div>
                      </div>

                      <div className="row mb-md-3">
                        <div className="col-sm-8">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.address")}
                            details={shops.address}
                          />
                        </div>
                      </div>
                      <div className="row mb-md-3">
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.zipCode")}
                            details={shops.zip_code}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.country")}
                            details={shops.country?.name}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.city")}
                            details={shops.city?.name}
                          />
                        </div>
                      </div>
                      <div className="row mb-md-3"></div>

                      <div className="row mb-md-3">
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.latitude")}
                            details={shops?.latitude}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.longitude")}
                            details={shops?.longitude}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.nSiteID")}
                            details={shops?.n_site_id}
                          />
                        </div>
                      </div>
                      <div className="row mb-md-3">
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.nControllerID")}
                            details={shops.n_controller_id}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.nControlType")}
                            details={shops?.n_control_type}
                          />
                        </div>
                        <div className="col-sm">
                          <UnlimitFieldDetails
                            heading={t("inputField.label.nControlIndex")}
                            details={shops?.n_control_index}
                          />
                        </div>
                      </div>
                      <div className="row mb-md-3">
                        <div className="col-md-4">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.createdBy")}
                            details={shops.created_by?.name}
                          />
                        </div>
                        <div className="col-md-4">
                          <UnlimitFieldDetails
                            heading={t("tableColumnName.createdAt")}
                            details={moment(shops.created_at).format(
                              "DD MMM YYYY - HH:mm:ss"
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          )}
          <Collapse accordion items={items} defaultActiveKey={["1"]} className="mb-4"/>
        </div>
      </div>
    </>
  );
}
